// INPUT: foo.do?bar=x&contentId=1&contentId=2&contentId=3
// OUTPUT: ["1","2","3"]
export const extractMultipleIdsFromUrl = (idName, url) => {
    const ret = [];
    // REMOVE FIRST URL PARTS
    const index = url.indexOf(idName);
    const urlShortFront = url.substring(index);
    const urlParamPairs = urlShortFront.split('&');
    for (const pair of urlParamPairs) {
        if (pair.startsWith(idName)) {
            const repl = pair.replace(idName + '=', '');
            ret.push(repl);
        }
    }
    return ret;
};
